// extracted by mini-css-extract-plugin
export default {"container":"InfiniteScroll_container__Pwa03","emptyMessage":"InfiniteScroll_emptyMessage__SS32i"};